/**
 * Returns overdue status
 * @param deadline deadline date
 */
export const checkOverdue = (deadline?: string | number): boolean => {
    return deadline ? Number(new Date()) - Number(new Date(deadline)) > 0 : false;
};
